import React, { useContext, useEffect, useMemo, useState } from "react";
import LocaleContext from "../../../constants/localization";
import { MapContainer } from "react-leaflet";
import { isEmpty } from "lodash";
import { getGeometryBounds } from "actions/spectrumActions";
import MapLayersComponent from "components/common/MapLayersComponent";
import GeometryFieldComponent from "components/common/GeometryFieldComponent";
import API from "constants/api";
import { finCRS } from "../../../map/finCRS";

import * as L from "leaflet";
import "@geoman-io/leaflet-geoman-free";
import "@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css";
import "proj4";
import "proj4leaflet";
import "leaflet/dist/leaflet.css";
import Header from "../common/Header";
import MapClickEventComponent from "../../common/MapClickEventComponent";

export default function LocationDisplay({ field }) {
  const [display, setDisplay] = useState(false);
  const [wfsEnabled, setWfsEnabled] = useState(false);
  const [getFeatureInfoEnabled, setGetFeatureInfoEnabled] = useState(false);
  const [layerConfig, setLayerConfig] = useState({});
  const LS = useContext(LocaleContext);

  let mapCenter = [61.777460617359054, 24.7476951251703];
  let zoom = 0;

  useEffect(() => {
    fetch(API.MAP_CONFIG)
      .then((res) => res.json())
      .then((res) => {
        if (!isEmpty(res)) {
          setWfsEnabled(res.wfs.enabled);
          setGetFeatureInfoEnabled(res.getFeatureInfo.enabled);
          if (!isEmpty(res.layers)) {
            setLayerConfig(res.layers);
          }
        }
      });
  }, []);

  const displayMap = useMemo(
    () => (
      <div>
        <MapContainer
          center={mapCenter}
          style={{ height: "75vh", width: "100%", cursor: "crosshair" }}
          zoom={zoom}
          crs={finCRS}
          scrollWheelZoom={true}
          maxBounds={[
            [57.15273773771963, 50.28861573758486],
            [73.61064411453262, 10.730096654154679],
          ]}
          whenCreated={(map) => {
            if (field.values.length > 0) {
              map.fitBounds(getGeometryBounds(field));
            }
            L.DomUtil.addClass(map._container, "crosshair-cursor-enabled");
          }}
        >
          <GeometryFieldComponent field={field} />
          <MapLayersComponent
            layerConfig={layerConfig}
            wfsEnabled={wfsEnabled}
          />
          <MapClickEventComponent
            searchView={false}
            getFeatureInfoEnabled={getFeatureInfoEnabled}
            overlayMapDetails={layerConfig.overlayMapDetails}
          />
        </MapContainer>
      </div>
    ),
    [wfsEnabled, getFeatureInfoEnabled, layerConfig]
  );

  if (display) {
    return (
      <div className="field">
        <Header field={field} />
        <button
          type="button"
          onClick={() => {
            setDisplay(false);
          }}
        >
          {LS.actions.close}
        </button>
        {displayMap}
      </div>
    );
  } else {
    return (
      <div className="field">
        <Header field={field} />
        <button
          type="button"
          onClick={() => {
            setDisplay(true);
          }}
        >
          {LS.actions.open}
        </button>
      </div>
    );
  }
}
